export default __webpack_public_path__ + "static/media/down-arrow.c842f22c.svg";